// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"435":"b40cd2de","9103":"b9ea4917"}[chunkId] + ".css";
};